<template>
  <span class="m-input-edit">
    <div class="m-input-edit__text">
      <span ref="text" v-if="!editing">{{ text }}</span>
      <span v-show="editing">
        <VInput ref="input" type="text" v-model="changedTitle" :fluid="true" size="small" />
      </span>
    </div>
    <span class="m-input-edit__edit-button" v-if="!editing" @click="edit">
      <PencilIcon
        height="10"
        width="9"
      />
    </span>
    <span class="m-input-edit__save-button" :class="{ disabled: saveDisabled }" v-if="editing" @click="save">
      <CheckIcon
        height="10"
        width="10"
      />
    </span>
    <span class="m-input-edit__cancel-button" v-if="editing" @click="cancel">
      <XMarkIcon
        height="10"
        width="10"
      />
    </span>
  </span>
</template>

<script>
import VInput from '@/components/deprecated/atoms/Input.vue';
import { CheckIcon, PencilIcon, XMarkIcon } from '@/components/icons/fontIcons';

export default {
  name: 'VInputEdit',
  props: {
    text: {
      type: [String],
      required: true,
    },
  },
  components: {
    VInput,
    CheckIcon,
    PencilIcon,
    XMarkIcon,
  },
  data() {
    return {
      changedTitle: this.text,
      editing: false,
      inputWidth: 0,
    };
  },
  computed: {
    saveDisabled() {
      return this.changedTitle === '';
    },
  },
  methods: {
    edit() {
      const input = this.$refs.input.$el.children[0];
      const textWidth = this.$refs.text.offsetWidth;

      this.editing = true;

      input.click();
      this.inputWidth = textWidth + 5;
    },
    save() {
      if (this.saveDisabled) {
        return;
      }

      this.editing = false;
      if (this.text !== this.changedTitle) {
        this.$emit('saved', { title: this.changedTitle });
      }
    },
    cancel() {
      this.editing = false;
      this.changedTitle = this.text;
    },
  },
};
</script>

<style scoped>
.m-input-edit__edit-button, .m-input-edit__save-button, .m-input-edit__cancel-button {
  margin-left: var(--spacing-small);
  color: #fff;
  line-height: 0;
  display: inline-block;
  border-radius: 30px;
  cursor: pointer;
}

.m-input-edit__text {
  display: inline-block;
  max-width: calc(100% - 100px);
  text-overflow: ellipsis;
  vertical-align: middle;
}

.m-input-edit__edit-button {
  border: 1px solid var(--signable-secondary-3);
  background-color: var(--signable-secondary-3-shade-1);
  padding: calc(var(--spacing-xs) + 3px);
}

.m-input-edit__save-button {
  border: 1px solid var(--color-success-dark);
  background: var(--color-success);
  padding: calc(var(--spacing-xs) + 3px);
}

.m-input-edit__save-button:hover {
  background: var(--color-success-dark);
}

.m-input-edit__save-button.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background: var(--color-success);
}

.m-input-edit__cancel-button {
  border: 1px solid var(--color-error-dark);
  background: var(--color-error);
  padding: calc(var(--spacing-xs) + 3px);
}

.m-input-edit__cancel-button:hover {
  background: var(--color-error-dark);
}

.m-input-edit ::v-deep .a-input input {
  padding: 0 var(--spacing-small);
}
</style>
